import api from '@/api';
import { QuestCommissionByMovementRequest } from '../../../Reports/CommssionByMovement/CommissionByMovement.types';
import { API_BASE_URL } from '../../..';

const CONTROLLER_URL = `${API_BASE_URL}/Csv`;

export async function getQuestReportCsvCommisionByMovement(
  params: QuestCommissionByMovementRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/CommissionByMovement`,
    params,
  )) as unknown;

  return result as BlobPart;
}
